
import React from "react";
import { LucideIcon } from "lucide-react";

interface IconListItemProps {
  icon: LucideIcon;
  text: string;
}

export function IconListItem({ icon: Icon, text }: IconListItemProps) {
  return (
    <div className="flex items-center gap-2">
      <Icon className="h-4 w-4 text-grandpal-green flex-shrink-0" />
      <span className="text-sm">{text}</span>
    </div>
  );
}
